// import { Icon } from 'antd@';
import { createFromIconfontCN } from '@ant-design/icons';
const IconFont = createFromIconfontCN({
  // scriptUrl: '//at.alicdn.com/t/font_890761_az9rg75hxb.js'
  scriptUrl: './scss/js/ali_font.js'
});

export default IconFont;
